/**
 * Route-prefix allow-list + a tiny home-view validator, shared by both the
 * app shell (App.tsx — RouteMemory persistence, RootRedirect landing) and
 * the CommandPalette (the "set home view" action). Lives in its own module
 * so the palette can reuse `isValidHomeView` WITHOUT importing App.tsx,
 * which would create an import cycle (App.tsx imports CommandPalette).
 */

// Route prefixes the SPA actually serves (mirrors <Routes> in App.tsx;
// startsWith so /bess/:id and /alarms/rules match). RouteMemory only
// persists matching paths — without this guard a typo'd deep link would
// be saved, restored onto the NotFound card on every subsequent boot,
// and re-save itself forever.
export const VALID_ROUTE_PREFIXES = [
  "/overview", "/flow", "/bess", "/historical", "/analytics", "/revenue",
  "/market-price", "/alarms", "/schedule", "/controller", "/site",
];

/**
 * Whether `route` is a usable per-site home-view target. Mirrors the
 * readLastRoute guard (reject "/" and non-matching prefixes) so a
 * renamed/stale saved home view silently falls back instead of stranding
 * an operator on a NotFound card.
 */
export function isValidHomeView(route: string): boolean {
  return (
    typeof route === "string"
    && route.startsWith("/")
    && route !== "/"
    && VALID_ROUTE_PREFIXES.some((p) => route.startsWith(p))
  );
}
